import { render } from "./ContentWiki.vue?vue&type=template&id=616b2541&scoped=true"
import script from "./ContentWiki.vue?vue&type=script&lang=js"
export * from "./ContentWiki.vue?vue&type=script&lang=js"

import "./ContentWiki.vue?vue&type=style&index=0&id=616b2541&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616b2541"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput});
